import { Component } from "react";
import image from "../../src/assets/images/networkerror.png"
class ErrorBoundary extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      hasError: false,
      isOffline: !navigator.onLine,
      isNetworkError: false,
    };
  }

  static getDerivedStateFromError(error) {
    const msg = (error && (error.message || error.toString())) || '';
    const networkPatterns = [
      /network error/i,
      /failed to fetch/i,
      /load failed/i,
      /request failed/i,
      /net::ERR/i,
      /TypeError: Failed to fetch/i,
    ];
    const isNetworkError =
      networkPatterns.some((re) => re.test(msg)) ||
      (error && error.isAxiosError && !error.response);

    return { hasError: true, isNetworkError };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Error occurred within the ErrorBoundary', error, errorInfo);
  }

  componentDidMount() {
    window.addEventListener('online', this.handleOnline);
    window.addEventListener('offline', this.handleOffline);
  }

  componentWillUnmount() {
    window.removeEventListener('online', this.handleOnline);
    window.removeEventListener('offline', this.handleOffline);
  }

  handleOnline = () => this.setState({ isOffline: false });
  handleOffline = () => this.setState({ isOffline: true });

  handleRetry = () => {
    if (!navigator.onLine) return;
    this.setState({ hasError: false, isNetworkError: false });
    window.location.reload();
  };

  render() {
    const { hasError, isOffline, isNetworkError } = this.state;
    if (isOffline || (hasError && isNetworkError)) {
      return (
        <div className="error-handler text-muted d-flex  justify-content-around flex-column text-center p-3">
          <div className="bg-body py-3 px-4 mx-auto rounded-3 shadow-sm">
<img loading="lazy" decoding="async" src={image} className='w-50' alt="خطا"/>
            <h4 className="py-4 title-wrap text-center">اتصال اینترنت شما قطع است</h4>
            <p className="mb-4 modal-text-wrap text-center">
              لطفاً اتصال اینترنت خود را بررسی کنید
            </p>
            <div className="w-100 text-center">
               <a href="/" className="btn  btn-success">
              صفحه اصلی
            </a>
               
            </div>
          </div>
        </div>
      );
    }
//dise
    // if (hasError) {
    //    return (
    //     <div className="error-handler text-muted d-flex justify-content-center flex-column text-center">
    //       <div className="bg-body py-3 px-4 mx-auto rounded-3 shadow-sm" style={{ maxWidth: 520 }}>
    //         <h4 className="p-3 "> متاسفانه خطای غیرمنتظره‌ای رخ داده است</h4>
    //         <p className="mb-3">روی «تلاش مجدد» بزنید</p>
    //         <div className="d-flex gap-2 justify-content-center mt-3 w-100">
    //           <button onClick={this.handleRetry} className="btnModal">
    //             تلاش مجدد
    //           </button>
    //           <button className="btnModal"> <a href="/">
    //             صفحه اصلی
    //           </a></button>
    //         </div>
    //       </div>
    //     </div>
    //   );
     
    // }

    return this.props.children;
  }
}

export default ErrorBoundary;
